export const CURRENT_QUOTE_DATA = "CURRENT_QUOTE_DATA";
export const QUOTE_SUPPORT_DATA = "QUOTE_SUPPORT_DATA";
export const CURRENT_STEP = "CURRENT_STEP";
export const AGENCY_STATES = "AGENCY_STATES";
